var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsLargeNoimgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 60,
    viewBox: "0 0 48 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5849_29725)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.774414 0.967773V59.0323H47.4858V0.967773H0.774414ZM28.3856 55.9763H19.8797V42.5756H28.3856V55.9763ZM44.4349 55.9763H31.4416V39.5196H16.8237V55.9763H3.83044V4.0238H44.4298V55.9763H44.4349Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4517 9.39746H8.93896V20.5571H22.4517V9.39746ZM19.3957 17.501H11.995V12.4535H19.3957V17.501Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7539 9.39746H26.2412V20.5571H39.7539V9.39746ZM36.6979 17.501H29.2972V12.4535H36.6979V17.501Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4517 24.3613H8.93896V35.5209H22.4517V24.3613ZM19.3957 32.4649H11.995V27.4174H19.3957V32.4649Z",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7539 24.3613H26.2412V35.5209H39.7539V24.3613ZM36.6979 32.4649H29.2972V27.4174H36.6979V32.4649Z",
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5849_29725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.7114,
    height: 58.0645,
    fill: "white",
    transform: "translate(0.774414 0.967773)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsLargeNoimgBuilding);
export default __webpack_public_path__ + "static/media/icons_large_noimg_building.b7c279990bf69f3e4f7f248a97d14d01.svg";
export { ForwardRef as ReactComponent };